import React from 'react';
import QuizSubjectTopics from '../../topics/QuizSubjectTopics';

function QuizPhysicsTopics() {
  return (
   <>
   
   <QuizSubjectTopics name="quiz" link="quiz/physics" type="quiz" subject="physics" topic="atoz" subjectName="physics" />
   
   </>
  );
}

export default QuizPhysicsTopics;